<!--
 * @description: add-modal
 * @author: 06455
 * @date: 2023/12/13 15:11
-->
<template>
  <ls-drawer title="新增" width="100%" :visible="modal" @close="modal = false">
    <ls-table-layout>
      <template #search>
        <lsSearchForm ref="lsSearchForm" @search="handleSearch" :formList="formList" @reset="reset">
          <template #internalExclusiveIsTitle>
            <span
            >是否独占（内
              <a-tooltip title="是否独占（内外部）">
                <a-icon type="question-circle-o" />
              </a-tooltip>
            </span>
          </template>
          <ls-select
            slot="supplierDelayInStockIs"
            v-decorator="['supplierDelayInStockIs']"
            :showSearch="true"
            placeholder="请选择"
            :options="TRUE_IS"
            :filter-option="filterOption"
            allowClear
          />
          <ls-select
            slot="internalExclusiveIs"
            v-decorator="['internalExclusiveIs']"
            :showSearch="true"
            placeholder="请选择"
            :options="INNER_OUT"
            :filter-option="filterOption"
            allowClear
          />
          <ls-select
            slot="multiWarehouseIs"
            v-decorator="['multiWarehouseIs']"
            :showSearch="true"
            placeholder="请选择"
            :options="TRUE_IS"
            :filter-option="filterOption"
            allowClear
          />
          <template #supplierExclusiveIsTitle>
            <span
            >是否独占（单
              <a-tooltip title="是否独占（单工厂）">
                <a-icon type="question-circle-o" />
              </a-tooltip>
            </span>
          </template>
          <ls-select
            slot="supplierExclusiveIs"
            v-decorator="['supplierExclusiveIs']"
            :showSearch="true"
            placeholder="请选择"
            :options="FACTORY_IS"
            :filter-option="filterOption"
            allowClear
          />
          <ls-select
            slot="billType"
            v-decorator="['billType']"
            :showSearch="true"
            placeholder="请选择"
            :options="BILL_TYPE_LIST"
            :filter-option="filterOption"
            allowClear
          />
          <ls-select
            slot="factoryCodeList"
            v-decorator="['factoryCodeList']"
            :showSearch="true"
            placeholder="请选择"
            :options="selectSupplierList"
            :filter-option="filterOption"
            allowClear
            mode="multiple"
            @search="handleSupplierSearch"
          />
          <a-row slot="currentDayUnderShipmentQty">
            <a-col :span="12">
              <ls-select
                v-model="formData.currentDayUnderShipmentQtyType"
                :showSearch="true"
                placeholder="请选择"
                :options="RANGE_LIST"
                :filter-option="filterOption"
              />
            </a-col>
            <a-col :span="12">
              <a-input-number v-model="formData.currentDayUnderShipmentQtyValue" style="width: 100%" />
            </a-col>
          </a-row>
          <a-row slot="factoryUnplanQty">
            <a-col :span="12">
              <ls-select
                v-model="formData.factoryUnplanQtyType"
                :showSearch="true"
                placeholder="请选择"
                :options="RANGE_LIST"
                :filter-option="filterOption"
              />
            </a-col>
            <a-col :span="12">
              <a-input-number v-model="formData.factoryUnplanQtyValue" style="width: 100%" />
            </a-col>
          </a-row>
          <a-range-picker
            slot="requireDeliveryDay"
            v-decorator="[`requireDeliveryDay`]"
            style="width: 100%"
            :placeholder="['开始日期', '结束日期']"
          />
          <ls-select
            slot="warehouseCode"
            v-decorator="['warehouseCode']"
            :showSearch="true"
            placeholder="请选择"
            :options="selectWarehouseList"
            :filter-option="filterOption"
            allowClear
          />
          <template #internalFulfillIsTitle>
            <span
            >内部计划是...
              <a-tooltip title="内部计划是否满足">
                <a-icon type="question-circle-o" />
              </a-tooltip>
            </span>
          </template>
          <ls-select
            slot="internalFulfillIs"
            v-decorator="['internalFulfillIs']"
            :showSearch="true"
            placeholder="请选择"
            :options="TRUE_IS"
            :filter-option="filterOption"
            allowClear
          />
          <lsSelectPage
            slot="dispatcherNo"
            v-decorator="['dispatcherNo']"
            :datas="dispatcherList"
            searchKey="dispatcher"
            valueKey="jobNo"
            placeholder="请选择"
          >
            <template slot="select-option" slot-scope="{items}">
              <a-select-option v-for="(i, index) in items" :key="index" :value="i.jobNo" :title="i.realName">
                {{ `${i.jobNo}-${i.realName}` }}
              </a-select-option>
            </template>
          </lsSelectPage>
          <ls-select
            slot="earlyMorningDeliveryIs"
            v-decorator="['earlyMorningDeliveryIs']"
            :showSearch="true"
            placeholder="请选择"
            :options="MORNING_OR_EVENING_LIST"
            :filter-option="filterOption"
            allowClear
          />
          <global-select
            slot="businessType"
            v-decorator="['businessType']"
            :selectData="businessTypeList"
            selectType="selectFilter"
            :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
          />
        </lsSearchForm>
        <a-checkbox v-model="isUnderShipment" @change="handleSearch($refs.lsSearchForm.form.getFieldsValue())" style="margin-top: 10px;">欠货/非欠货(勾选为欠货)</a-checkbox>
        <a-button type="primary" class="batch-remark-btn" @click="onBatchRemark">批量备注</a-button>
        <batch-edit-modal ref="batchEditModalRef" @updateRemark="batchUpdateRemark" />
      </template>
      <template #table>
        <ls-api-table
          ref="baseTable"
          class="stripeTable"
          :columns="columns"
          :tableProps="tableProps"
          :selectedRows.sync="selectedRows"
          :pagination="pagination"
          :multi-select="true"
          :scroll="{ fixScreen: true, extraHeight: 70, x: 1800 }"
          bordered
          :custom-selection="{ stickyFixed: true }"
          @change="sortFun"
        >
          <!--要求到仓数量标题-->
          <template #requireDeliveryQuantityTitle>
            <span style="color: red">*</span>
            <span>要求到仓数量</span>
          </template>
          <!--要求到仓数量-->
          <template #requireDeliveryQuantity="{ text, record }">
            <a-input-number
              v-model="record.requireDeliveryQuantity"
              :min="0"
              :max="record.factoryUnplanQtyWithWarehouse"
              :formatter="(value) => `${value}`.replace(/^(\-)*(\d+)\.(\d{2}).*$/, '$1$2.$3', '')"
              :parser="(value) => value.replace(/^(\-)*(\d+)\.(\d{2}).*$/, '$1$2.$3', '')"
              @change="(e) => changeRequireDeliveryQuantity(e, record)"
              size="small"
              style="width:100%"
            />
          </template>
          <!--备注-->
          <template #remark="{ text, record }">
            <a-input
              v-model="record.remark"
              size="small"
              :maxLength="150"
            />
          </template>
          <!--要求到货日期标题-->
          <template #requireDeliveryDayTitle>
            <span style="color: red">*</span>
            <span @click="changeAllDay">要求到货日期</span>
          </template>
          <!--要求到货日期-->
          <template #requireDeliveryDay="{ text, record }">
            <a-date-picker
              v-model="record.requireDeliveryDay"
              @change="changeRequireDeliveryDay($event, record)"
              :disabled-date="disabledStartDate"
              size="small"
            />
          </template>
          <!--当前订单满足率-->
          <template #orderSatisfyRate="{ text }">
            <span>{{ !isNullFun(text) ? fix2NumPercentFun(text) : '' }}</span>
          </template>
          <!--客审未货审订单-->
          <template #orderQtyTitle>
            <span class="marginRight">客审未货审订单</span>
            <a-tooltip placement="top" title="取每天BI报表的数据，若当日BI报表生成有问题则延用前一天获取的数据">
              <a-icon type="info-circle" />
            </a-tooltip>
          </template>
          <!--全部工厂已排数量-->
          <template #planedQtyTitle>
            <span class="marginRight">全部工厂已排数量</span>
            <a-tooltip placement="top" title="分仓计划在途量+调拨计划安排量+外部计划在途量">
              <a-icon type="info-circle" />
            </a-tooltip>
          </template>
          <!--当前库存可用数-->
          <template #inventoryQtyTitle>
            <span class="marginRight">当前库存可用数</span>
            <a-tooltip placement="top" title="全部工厂已排数量+4PL库存现有量">
              <a-icon type="info-circle" />
            </a-tooltip>
          </template>
          <!--当前现货数量-->
          <template #surplusQtyTitle>
            <span class="marginRight">当前现货数量</span>
            <a-tooltip placement="top" title="当前库存可用数-客审未货审订单">
              <a-icon type="info-circle" />
            </a-tooltip>
          </template>
          <!--当前订单满足率-->
          <template #orderSatisfyRateTitle>
            <span class="marginRight">当前订单满足率</span>
            <a-tooltip placement="top" title="当前库存可用数/客审末货审订单*100%" >
              <a-icon type="info-circle" />
            </a-tooltip>
          </template>
          <template slot="footer">
            <a-table
              bordered
              :row-key="(record, index) => index"
              :showHeader="false"
              class="footerTable"
              :columns="footerTableColumns"
              :data-source="sumInfoList"
              :pagination="false"
            >
              <template #summation>
                <span>合计</span>
              </template>
              <template #requireDeliveryQuantity>{{ sumRequireDeliveryQuantity }}</template>
              <template #totalVolume>{{ sumTotalVolume }}</template>
            </a-table>
          </template>
        </ls-api-table>
      </template>
    </ls-table-layout>
    <a-row>
      <a-space class="footer">
        <a-button @click="cancel">取消</a-button>
        <a-button type="primary" @click="submit" :loading="btnLoading">确认</a-button>
      </a-space>
    </a-row>
  </ls-drawer>
</template>

<script>
import {
  YES_OR_NO,
  INNER_OUT,
  TRUE_IS,
  BILL_TYPE_LIST,
  BILLTYPE,
  INTERNAL_EXCLUSIVE_MAP,
  RANGE_LIST,
  FACTORY_IS,
  MORNING_OR_EVENING,
  CREATE_IS_LIST,
  MORNING_OR_EVENING_LIST
} from '@/views/mes/scheduling-plan/receiving-plan/enum'
import common from '../mixins/common'
import {
  apiReceiptPlanUnderShipmentGetList,
  apiReceiptPlanUnderShipmentGetTotal,
  apiReceiptPlanAdd,
  apiGetsupplier,
  apiReceiptPlanUnderShipmentListSum, apiGetDispatchList
} from '@/services/module/receiving-plan'
import batchEditModal from '@/views/mes/scheduling-plan/receiving-plan/components/batch-edit-modal.vue'
import { fixedTable } from "lsmy-libs";
import cacheRequest from '@/mixins/cacheRequest'

export default {
  name: 'AddModal',
  components: { batchEditModal },
  mixins: [
    common,
    fixedTable,
    cacheRequest
  ],
  inject: ['warehouseList'],
  computed: {
    selectWarehouseList () {
      return this.warehouseList?.()
    },
    footerTableColumns () {
      return [
        {
          title: '勾选',
          align: 'center',
          width: 60,
          stickyFixed: 'left'
        },
        {
          title: '合计',
          scopedSlots: { customRender: 'summation' },
          align: 'center',
          width: 40,
          stickyFixed: 'left'
        },
        ...this.columns.slice(1)
      ]
    }
  },
  data () {
    return {
      INNER_OUT,
      TRUE_IS,
      BILL_TYPE_LIST,
      RANGE_LIST,
      FACTORY_IS,
      modal: false,
      isUnderShipment: true,
      formData: {
        factoryUnplanQty: {
          value: undefined,
          type: 'eq'
        },
        currentDayUnderShipmentQty: {
          value: undefined,
          type: 'eq'
        },
        factoryUnplanQtyType: 'eq',
        factoryUnplanQtyValue: undefined,
        currentDayUnderShipmentQtyType: 'eq',
        currentDayUnderShipmentQtyValue: undefined
      },
      formList: [
        {
          label: '物料编码',
          type: 'input',
          decorator: ['materialNo'],
          attrs: {
            placeholder: '请输入'
          }
        },
        {
          label: '供应商',
          decorator: ['factoryCodeList'],
          type: 'factoryCodeList'
        },
        {
          label: '延期入库供应商',
          decorator: ['supplierDelayInStockIs'],
          type: 'supplierDelayInStockIs'
        },
        {
          label: '工厂可排数量',
          type: 'factoryUnplanQty'
        },
        {
          label: '是否独占（内外部）',
          labelSlot: 'internalExclusiveIsTitle',
          type: 'internalExclusiveIs'
        },
        {
          label: '要求到货日期',
          type: 'requireDeliveryDay'
        },
        {
          label: '当天欠货数量',
          type: 'currentDayUnderShipmentQty'
        },
        {
          label: '采购单据类型',
          type: 'billType'
        },
        {
          label: '入库仓库',
          type: 'warehouseCode'
        },
        {
          label: '供应商仓库',
          type: 'input',
          decorator: ['factoryWarehouseName'],
          attrs: {
            placeholder: '请输入'
          }
        },
        {
          label: '是否多仓',
          type: 'multiWarehouseIs'
        },
        {
          label: '是否独占（单工厂）',
          labelSlot: 'supplierExclusiveIsTitle',
          type: 'supplierExclusiveIs'
        },
        {
          label: '内部计划是否满足',
          labelSlot: 'internalFulfillIsTitle',
          type: 'internalFulfillIs'
        },
        {
          label: '调度员',
          type: 'dispatcherNo'
        },
        {
          label: '是否早班送货',
          type: 'earlyMorningDeliveryIs'
        },
        {
          label: '物料名称',
          type: 'input',
          decorator: ['materialName'],
          attrs: {
            placeholder: '请输入'
          }
        },
        { label: '业务类型', type: 'businessType' }
      ],
      columns: [
        {
          title: '序号',
          dataIndex: 'serialNumber',
          align: 'center',
          width: 40,
          stickyFixed: 'left',
          ellipsis: true
        },
        {
          dataIndex: 'materialNo',
          title: '物料编码',
          width: 130,
          stickyFixed: 'left'
        },
        {
          dataIndex: 'factoryShortName',
          title: '供应商',
          width: 100,
          ellipsis: true
        },
        { dataIndex: 'businessTypeName', title: '业务类型', width: 80 },
        {
          dataIndex: 'delayQty',
          title: '在途延期入库',
          width: 60
        },
        {
          dataIndex: 'factoryPlanedQty',
          title: '本工厂已排数量',
          width: 60
        },
        {
          dataIndex: 'planedQty',
          // title: '全部工厂已排数量',
          scopedSlots: { title: 'planedQtyTitle' },
          sorter: true,
          sortDirections: ['ascend', 'descend'],
          width: 80
        },
        { dataIndex: 'bgBillQty', title: '已报工数量', width: 60 },
        { dataIndex: 'bgBillUnCompleteQty', title: '待报工数量', width: 60 },
        {
          dataIndex: 'qcUnPassQty',
          title: '报检中',
          width: 60
        },
        {
          dataIndex: 'factoryUnplanQty',
          title: '工厂可排数量',
          width: 60
        },
        {
          dataIndex: 'deliveryProductFlag',
          title: '是否快递产品',
          customRender: (text) => YES_OR_NO[text],
          width: 60
        },
        {
          dataIndex: 'jdcInvUseQty',
          title: '基地仓库存可用数',
          width: 60
        },
        {
          dataIndex: 'internalExclusiveIs',
          title: '是否独占(内外部)',
          customRender: (text) => (!this.isNull(text) ? INTERNAL_EXCLUSIVE_MAP[text] : ''),
          width: 60
        },
        {
          dataIndex: 'internalFulfillIs',
          title: '内部计划是否满足',
          customRender: (text) => YES_OR_NO[text],
          ellipsis: true,
          width: 60
        },
        {
          dataIndex: 'requireDeliveryQuantity',
          // title: "要求到仓数量",
          scopedSlots: { customRender: 'requireDeliveryQuantity', title: 'requireDeliveryQuantityTitle' },
          width: 110
        },
        {
          dataIndex: 'supplierPriorityLevel',
          title: '供应商入库优先级',
          width: 60
        },
        {
          dataIndex: 'surplusQty',
          // title: '当前现货数量',
          sorter: true,
          sortDirections: ['ascend', 'descend'],
          scopedSlots: { title: 'surplusQtyTitle' },
          width: 60
        },
        {
          dataIndex: 'inventoryQty',
          // title: '当前库存可用数',
          sorter: true,
          sortDirections: ['ascend', 'descend'],
          scopedSlots: { title: 'inventoryQtyTitle' },
          width: 60
        },
        {
          dataIndex: 'orderSatisfyRate',
          // title: '当前订单满足率',
          sorter: true,
          sortDirections: ['ascend', 'descend'],
          defaultSortOrder: 'ascend',
          scopedSlots: { customRender: 'orderSatisfyRate', title: 'orderSatisfyRateTitle' },
          width: 60
        },
        {
          dataIndex: 'avgSaleQty',
          title: '月均销量',
          width: 60
        },
        {
          dataIndex: 'curSaleQty',
          title: '实时销量',
          width: 60
        },
        {
          dataIndex: 'sumOrderSatisfyRate',
          title: '累计安排订单满足率',
          width: 60,
          customRender: (text) => (!this.isNull(text) ? this.fix2NumPercent(text, '%') : '')
        },
        {
          dataIndex: 'requireDeliveryDay',
          // title: "要求到货日期",
          scopedSlots: { customRender: 'requireDeliveryDay', title: 'requireDeliveryDayTitle' },
          width: 130
        },
        {
          dataIndex: 'totalVolume',
          title: '体积求和',
          scopedSlots: { customRender: 'totalVolume' },
          width: 60
        },
        {
          dataIndex: 'stockQuantity',
          title: '库位标准存放',
          sorter: true,
          sortDirections: ['ascend', 'descend'],
          width: 60
        },
        {
          dataIndex: 'depositAreaName',
          title: '存放区域',
          ellipsis: true,
          width: 80
        },
        {
          dataIndex: 'currentDayUnderShipmentQty',
          title: '当天欠货数量',
          width: 60
        },
        {
          dataIndex: 'fiveDayUnderShipmentQty',
          title: '5天欠货数量',
          width: 60
        },
        {
          dataIndex: 'tenDayUnderShipmentQty',
          title: '10天欠货数量',
          width: 60
        },
        {
          dataIndex: 'fiveteenDayUnderShipmentQty',
          title: '15天欠货数量',
          width: 60
        },
        {
          dataIndex: 'twentyDayUnderShipmentQty',
          title: '20天欠货数量',
          width: 60
        },
        {
          dataIndex: 'twentyFiveDayUnderShipmentQty',
          title: '25天欠货数量',
          width: 60
        },
        {
          dataIndex: 'thirtyDayUnderShipmentQty',
          title: '30天欠货数量',
          width: 60
        },
        {
          dataIndex: 'remark',
          title: '备注',
          scopedSlots: { customRender: 'remark' },
          width: 150
        },
        {
          dataIndex: 'deliveryDate',
          title: '交期',
          sorter: true,
          sortDirections: ['ascend', 'descend'],
          width: 100
        },
        {
          dataIndex: 'remainingLocation',
          title: '剩余库位数',
          width: 60
        },
        {
          dataIndex: 'presetLoadVolume',
          title: '预设装载体积',
          width: 60
        },
        {
          dataIndex: 'billType',
          title: '采购单据类型',
          width: 110,
          ellipsis: true,
          customRender: (text) => (!this.isNull(text) ? BILLTYPE[text] : '')
        },
        {
          dataIndex: 'canEnterJdcTally',
          title: '是否可入基地仓(理货)',
          width: 80
        },
        {
          dataIndex: 'warehouseName',
          title: '入库仓库',
          width: 80
        },
        {
          dataIndex: 'factoryWarehouseName',
          title: '供应商仓库',
          ellipsis: true,
          width: 130
        },
        {
          dataIndex: 'dischargeIs',
          title: '是否仓库卸货',
          customRender: (text) => YES_OR_NO[text],
          width: 40
        },
        {
          dataIndex: 'materialName',
          title: '物料名称',
          width: 100,
          ellipsis: true
        },
        {
          dataIndex: 'materialSpec',
          title: '规格描述',
          width: 180,
          ellipsis: true
        },
        {
          dataIndex: 'orderQty',
          // title: '客审未货审订单',
          sorter: true,
          sortDirections: ['ascend', 'descend'],
          scopedSlots: { title: "orderQtyTitle" },
          width: 60
        },
        {
          dataIndex: 'multiWarehouseIs',
          title: '是否多仓',
          customRender: (text) => YES_OR_NO[text],
          width: 40
        },
        {
          dataIndex: 'supplierExclusiveIs',
          title: '是否独占(单工厂)',
          customRender: (text) => YES_OR_NO[text],
          width: 60
        },
        {
          dataIndex: 'unStockProductIs',
          title: '是否新品',
          customRender: (text) => YES_OR_NO[text],
          width: 40
        },
        {
          dataIndex: 'loadRate',
          title: '装载率',
          width: 60,
          customRender: (text) => !this.isNull(text) ? this.fix2NumPercent(text, '%') : ''
        },
        {
          dataIndex: 'internalPlanArrangeQty',
          title: '分仓计划在途量',
          width: 60
        },
        {
          dataIndex: 'schedulePlanArrangeQty',
          title: '调拨计划安排量',
          width: 60
        },
        {
          dataIndex: 'dispatcherNo',
          title: '调度员编码',
          width: 80
        },
        {
          dataIndex: 'dispatcherName',
          title: '调度员',
          width: 70
        },
        {
          dataIndex: 'earlyMorningDeliveryIs',
          title: '是否早班送货',
          customRender: (text) => MORNING_OR_EVENING[text],
          width: 60
        }
      ],
      tableProps: {
        requestApi: (params) => {
          return new Promise((resolve, reject) => {
            apiReceiptPlanUnderShipmentGetList({ ...params, pageNum: params.page, page: undefined }).then((res) => {
              const rows = res.rows.map((item, index) => {
                return {
                  ...item,
                  serialNumber: (index + 1) + ((params.page - 1) * params.pageSize),
                  requireDeliveryDay: item.requireDeliveryDay || this.$moment(new Date()).add(1, 'days').format('YYYY-MM-DD')
                }
              })
              resolve(rows)
            }).catch((err) => {
              reject(err)
            })
          })
        },
        paginationApi: (params) => apiReceiptPlanUnderShipmentGetTotal({ ...params, pageNum: params.page, page: undefined }),
        customTableData: (res) => new Promise((resolve) => {
          resolve(res)
        }),
        customPagination: (res) =>
          new Promise((resolve) => {
            this.$refs.baseTable.myPagination.total = res.data
            const pageTotal = Math.ceil(res.data / this.$refs.baseTable.myPagination.pageSize)
            resolve(pageTotal)
          }),
        pageCurrent: true
      },
      selectedRows: [],
      orderBys: [
        {
          order: "ascend",
          property: "orderSatisfyRate"
        }
      ],
      pagination: {
        total: 0,
        pageSize: 50,
        current: 1,
        pageSizeOptions: ['50', '20', '100']
      },
      selectSupplierList: [],
      sumInfoList: [],
      businessTypeList: [], // 业务类型
      sumRequireDeliveryQuantity: 0,
      sumTotalVolume: 0,
      CREATE_IS_LIST,
      MORNING_OR_EVENING_LIST,
      btnLoading: false,
      dispatcherList: []
    }
  },
  created () {
    this.cacheLookupRequest('PO_SCM_BUSINESS_TYPE', { lookupType: 'PO_SCM_BUSINESS_TYPE', current: 1, pageSize: 999 }, 'businessTypeList')
    this.handleSupplierSearch('')
  },
  methods: {
    // 批量修改备注
    onBatchRemark() {
      if (this.selectedRows.length === 0) {
        return this.$message.warning('请勾选单据进行操作')
      }
      this.$refs.batchEditModalRef.show(this.selectedRows);
    },
    // 填写完备注后批量修改
    batchUpdateRemark(data) {
      if (data?.length > 0 && this.$refs?.baseTable?.myDataSource?.length > 0) {
        this.$refs.baseTable.myDataSource.forEach((item, index) => {
          const updateObj = data?.find((item2) => item2.serialNumber === item.serialNumber)
          if (updateObj) {
            this.$set(this.$refs.baseTable.myDataSource[index], 'remark', updateObj.remark)
          }
        })
        // this.$refs.baseTable.onClear(); // 清除选择
      }
    },
    // 合并表格设置同步滚动
    setScroll () {
      // 同步表与footer滚动
      const dom = this.$refs.baseTable.$el.querySelectorAll('.ant-table-body')[0]
      dom.addEventListener('scroll', () => {
        this.$refs.baseTable.$el.querySelectorAll('.ant-table-body')[1].scrollLeft = dom.scrollLeft
      }, true)
    },
    reset () {
      localStorage.setItem('addModalParams', '{}')
      this.formData = {
        factoryUnplanQty: {
          value: undefined,
          type: 'eq'
        },
        currentDayUnderShipmentQty: {
          value: undefined,
          type: 'eq'
        },
        factoryUnplanQtyType: 'eq',
        factoryUnplanQtyValue: undefined,
        currentDayUnderShipmentQtyType: 'eq',
        currentDayUnderShipmentQtyValue: undefined
      }
    },
    async show () {
      this.modal = true
      await this.getDispatchList()
      this.$nextTick(() => {
        this.setScroll();
        this.stickyFixedColumns(this.footerTableColumns)
        this.handleSearch()
      })
    },
    cancel () {
      this.modal = false
    },
    submit () {
      if (this.selectedRows.length === 0) {
        return this.$message.warning('请勾选单据进行操作')
      }
      this.$refs.baseTable.loading = true;
      this.btnLoading = true;
      Promise.all(this.selectedRows.map((item) => apiReceiptPlanAdd(item)))
        .then(() => {
          this.modal = false
          this.$emit('addSuccess')
        })
        .finally(() => {
          this.$refs.baseTable.loading = false;
          this.btnLoading = false
        })
    },
    handleSupplierSearch (val) {
      apiGetsupplier({ supplierQueryStr: val, page: 1, pageSize: 50 }).then(res => {
        this.selectSupplierList = res?.data?.map(item => {
          return {
            value: item.companyCode,
            label: item.companyName
          }
        }) || []
      })
    },
    searchSum (params) {
      apiReceiptPlanUnderShipmentListSum(params).then(res => {
        this.sumInfoList = [res.data]
      })
    },
    async handleSearch (items) {
      let query = {}
      if (items) {
        query = await this.haveItemList(items)
      } else {
        query = await this.itemList()
      }
      this.$refs.baseTable.searchParams = query
      this.searchSum(query)
      this.$refs.baseTable.asyncGetData()
    },
    // 异步处理有参数
    haveItemList (items) {
      return new Promise(resolve => {
        if (items['requireDeliveryDay'] && items['requireDeliveryDay'].length > 0) {
          items.requireDeliveryTimeStart = this.momentFun(items['requireDeliveryDay'][0], 'YYYY-MM-DD 00:00:00')
          items.requireDeliveryTimeEnd = this.momentFun(items['requireDeliveryDay'][1], 'YYYY-MM-DD 23:59:59')
          items.requireDelivery = [
            this.momentFun(items['requireDeliveryDay'][0], 'YYYY-MM-DD 00:00:00'),
            this.momentFun(items['requireDeliveryDay'][1], 'YYYY-MM-DD 23:59:59')
          ]
        } else {
          delete items.requireDeliveryTimeStart
          delete items.requireDeliveryTimeEnd
        }
        delete items.requireDeliveryDay
        delete items.searchFormLabel
        const query = {
          ...items,
          currentDayUnderShipmentQtyValue: this.formData.currentDayUnderShipmentQtyValue,
          currentDayUnderShipmentQtyType: this.formData.currentDayUnderShipmentQtyType,
          currentDayUnderShipmentQty: this.formData.currentDayUnderShipmentQtyValue ? {
            value: this.formData.currentDayUnderShipmentQtyValue || undefined,
            type: this.formData.currentDayUnderShipmentQtyType
          } : undefined,
          factoryUnplanQtyValue: this.formData.factoryUnplanQtyValue,
          factoryUnplanQtyType: this.formData.factoryUnplanQtyType,
          factoryUnplanQty: this.formData.factoryUnplanQtyValue ? {
            value: this.formData.factoryUnplanQtyValue || undefined,
            type: this.formData.factoryUnplanQtyType
          } : undefined,
          orderBys: this.orderBys,
          isUnderShipment: this.isUnderShipment,
          requireDelivery: items.requireDelivery || []
        }
        localStorage.setItem('addModalParams', JSON.stringify(query))
        this.$refs.baseTable.searchParams = query
        resolve(query)
      })
    },
    // 异步处理无参数
    itemList () {
      return new Promise(resolve => {
        let query = {}
        const queryParams = localStorage.getItem('addModalParams')
        if (queryParams === '{}' || !queryParams) {
          query = {
            ...this.formData,
            currentDayUnderShipmentQtyValue: this.formData.currentDayUnderShipmentQtyValue,
            currentDayUnderShipmentQtyType: this.formData.currentDayUnderShipmentQtyType,
            currentDayUnderShipmentQty: this.formData.currentDayUnderShipmentQtyValue ? {
              value: this.formData.currentDayUnderShipmentQtyValue || undefined,
              type: this.formData.currentDayUnderShipmentQtyType
            } : undefined,
            factoryUnplanQtyValue: this.formData.factoryUnplanQtyValue,
            factoryUnplanQtyType: this.formData.factoryUnplanQtyType,
            factoryUnplanQty: this.formData.factoryUnplanQtyValue ? {
              value: this.formData.factoryUnplanQtyValue || undefined,
              type: this.formData.factoryUnplanQtyType
            } : undefined,
            orderBys: this.orderBys,
            isUnderShipment: this.isUnderShipment
          }
        } else {
          query = JSON.parse(queryParams)
        }
        this.formData = {
          ...query,
          requireDeliveryDay: query?.requireDelivery
        }
        this.$refs.lsSearchForm.form.setFieldsValue({
          materialNo: query?.materialNo,
          factoryCodeList: query?.factoryCodeList,
          supplierDelayInStockIs: query?.supplierDelayInStockIs,
          factoryUnplanQtyValue: query?.factoryUnplanQtyValue,
          factoryUnplanQtyType: query?.factoryUnplanQtyType,
          factoryUnplanQty: query?.factoryUnplanQty,
          internalExclusiveIs: query?.internalExclusiveIs,
          requireDeliveryDay: query?.requireDelivery,
          currentDayUnderShipmentQtyValue: query?.currentDayUnderShipmentQtyValue,
          currentDayUnderShipmentQtyType: query?.currentDayUnderShipmentQtyType,
          currentDayUnderShipmentQty: query?.currentDayUnderShipmentQty,
          billType: query?.billType,
          warehouseCode: query?.warehouseCode,
          factoryWarehouseName: query?.factoryWarehouseName,
          multiWarehouseIs: query?.multiWarehouseIs,
          supplierExclusiveIs: query?.supplierExclusiveIs
        })
        resolve(query)
      })
    },
    // 后端排序
    sortFun (p, f, { field, order }) {
      this.orderBys = [
        {
          order: order,
          property: field
        }
      ]
      const query = {
        ...this.formData,
        orderBys: this.orderBys,
        isUnderShipment: this.isUnderShipment
      }
      delete query.searchFormLabel
      this.$refs.baseTable.searchParams = query
    },
    // 修改要求到货数量
    changeRequireDeliveryQuantity (e, record) {
      this.$set(record, 'requireDeliveryQuantity', e)
      this.$set(record, 'totalVolume', this.multiply(record.requireDeliveryQuantity, record.materialVolume))
      this.$set(record, 'locationQuantity', this.divide(record.requireDeliveryQuantity, record.qtyPerLocation))
      this.$set(record, 'sumOrderSatisfyRate', this.divide(this.add(record.inventoryQty, record.requireDeliveryQuantity), record.orderQty))
      // 自动勾选这行
      this.$refs.baseTable.onKeepSelect(record, true)
      // 合计到仓数
      this.getSumReguireDeliveryQuantity()
      // 合计体积
      this.getSumTotalVolume()
    },
    // 合计要求到仓数量
    getSumReguireDeliveryQuantity () {
      const list = this.$refs.baseTable.myDataSource
      this.sumRequireDeliveryQuantity = 0
      list.forEach(item => {
        this.sumRequireDeliveryQuantity = (item.requireDeliveryQuantity || 0) + this.sumRequireDeliveryQuantity
      })
    },
    // 合计体积
    getSumTotalVolume () {
      const list = this.$refs.baseTable.myDataSource
      this.sumTotalVolume = 0
      list.forEach(item => {
        this.sumTotalVolume = (item.totalVolume || 0) + this.sumTotalVolume
      })
    },
    // 点击标题批量修改到货日期
    changeAllDay () {
      const items = this.$refs.baseTable.keepSelectList
      if (items.length > 0) {
        items.forEach((item) => {
          this.$set(item, 'requireDeliveryDay', items[0].requireDeliveryDay)
        })
      }
    },
    // 修改要求到货日期
    changeRequireDeliveryDay (e, record) {
      this.$set(record, 'requireDeliveryDay', this.momentFun(e))
    },
    // 要求到货日期
    disabledStartDate (current) {
      // Can not select days before today and today
      return current && current < this.$moment(new Date()).subtract(1, 'days')
    },
    // 手动输入
    filterOption (input, option) {
      return option.componentOptions.children[0].text.toLowerCase().trim().indexOf(input.toLowerCase().trim()) >= 0
    },
    // 调整气泡提示位置
    getPopupContainer (trigger) {
      return trigger.parentElement;
    },
    // 转换方法
    isNullFun (text) {
      return this.isNull(text)
    },
    // 转换方法
    fix2NumPercentFun (text) {
      return this.fix2NumPercent(text, '%')
    },
    // 获取调度组成员列表
    getDispatchList () {
      return new Promise(resolve => {
        apiGetDispatchList().then(res => {
          if (res.code === 200) {
            this.dispatcherList = res.rows.map(item => {
              return {
                ...item,
                dispatcher: `${item.jobNo}-${item.realName}`
              }
            })
            resolve(this.dispatcherList)
          }
        })
      })
    }
  }
}
</script>

<style lang="less" scoped>
.stripeTable ::v-deep .ant-table-tbody tr:nth-child(2n) {
  background-color: #fafafa;

  .sticky-columns {
    background-color: #fafafa;
  }
}
.stripeTable{
  ::v-deep .ant-table-thead > tr > th, ::v-deep .ant-table-tbody > tr > td {
    padding: 4px;
  }
  .footerTable {
    ::v-deep .ant-table-thead > tr > th, ::v-deep .ant-table-tbody > tr > td {
      padding: 4px;
    }
  }
}
.batch-remark-btn{
  margin-left: 10px;
}

.footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-right: 10px;
}
.marginRight{
  margin-right: 8px;
}

</style>
